import { useLocation, useParams } from "react-router-dom"
import { SubscriptionContext } from "./SubscriptionContext"
import { useGetSubscription } from "../hooks/useGetSubscription"
import { useGetSubscriptionMember } from "../hooks/useGetSubscriptionMember"

type Props = { children: React.ReactNode }

export const SubscriptionProvider = ({ children }: Props) => {
  const { workspaceId } = useParams<{ workspaceId: string }>()
  const { pathname } = useLocation()

  const isAdminPath = pathname.includes("/console")
  const isMemberPath = pathname.includes("/project-portal")

  const adminQuery = useGetSubscription(workspaceId ?? "", {
    enabled: !!workspaceId && isAdminPath,
  })

  const memberQuery = useGetSubscriptionMember(workspaceId ?? "", {
    enabled: !!workspaceId && isMemberPath,
  })

  if (isAdminPath) {
    const { data, isLoading, isError, refetch } = adminQuery
    if (isLoading || !data) return null
    const isReadOnly = data.status === "expired" || data.status === "grace_period"
    return (
      <SubscriptionContext.Provider
        value={{ role: "admin", subscription: data, isReadOnly, isLoading, isError, refetch }}
      >
        {children}
      </SubscriptionContext.Provider>
    )
  }

  const { data, isLoading, isError, refetch } = memberQuery
  if (isLoading || !data) return null

  const isReadOnly = data.status === "expired" || data.status === "grace_period"
  const value = { role: "member" as const, subscription: data, isReadOnly, isLoading, isError, refetch }

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  )
}
